import React from 'react'

function DeleteAccount() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Delete Your Account</h1>
        <p className="text-gray-700 mb-6">
          If you are a delivery partner and wish to delete your Star Nutrition Delivery app account and all associated data, please follow the steps below. Deleting your account is permanent and cannot be undone.
        </p>

        <ol className="list-decimal list-inside text-gray-700 space-y-4 mb-8">
          <li>
            <strong>Contact Admin:</strong> Account deletion requests must be submitted to your company admin. Only the admin can permanently delete your account and all related data (profile, delivery history, etc.).
          </li>
          <li>
            <strong>Email Request:</strong> Send an email to <a href="mailto:support@starnutritionsupplements.com" className="text-blue-600 underline">support@starnutritionsupplements.com</a> from your registered email or phone number, requesting account deletion. Please include your name, phone number, and reason for deletion.
          </li>
          <li>
            <strong>Admin Review:</strong> The admin will verify your identity and process your request. You will receive a confirmation once your account and all associated data have been deleted from our system.
          </li>
        </ol>

        <div className="bg-gray-100 p-4 rounded mb-6">
          <p className="text-gray-800">
            <strong>What will be deleted?</strong><br />
            • Your profile information (name, phone, email, address)<br />
            • Delivery history and order records<br />
            • Device and login data<br />
            • All app usage data associated with your account
          </p>
        </div>

        <p className="text-gray-700 mb-2">
          <strong>Note:</strong> Once your account is deleted, you will not be able to log in or recover any data. If you have any questions, contact our support team at <a href="mailto:support@starnutritionsupplements.com" className="text-blue-600 underline">support@starnutritionsupplements.com</a>.
        </p>
      </div>
    </div>
  )
}

export default DeleteAccount